module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict6.6670592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict6.png
// module id = DjjG
// module chunks = 0